"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mountReactComponent = void 0;
var react_dom_1 = __importDefault(require("react-dom"));
var react_1 = __importDefault(require("react"));
var PromptContext_1 = require("Prompt/PromptContext");
var DIProvider_1 = require("DIProvider/DIProvider");
var mountReactComponent = function (createUi, di) {
    return function (component, options) {
        return createUi(require("./MountReactComponent.html"), {
            $init: options && options.$init,
            $onElementRendered: function (elem) {
                var componentWithDIProvider = react_1.default.createElement(DIProvider_1.RootDIProvider, { di: di }, component);
                if (di && di.has("promptOrchestrator")) {
                    var promptOrchestrator = di.get("promptOrchestrator");
                    react_dom_1.default.render(react_1.default.createElement(PromptContext_1.PromptProvider, { value: { promptOrchestrator: promptOrchestrator } }, componentWithDIProvider), elem[0]);
                }
                else {
                    react_dom_1.default.render(componentWithDIProvider, elem[0]);
                }
                elem.on("$destroy", function () {
                    react_dom_1.default.unmountComponentAtNode(elem[0]);
                    if (options && options.onDestroy) {
                        options.onDestroy();
                    }
                });
            },
        });
    };
};
exports.mountReactComponent = mountReactComponent;
exports.default = exports.mountReactComponent;
